import React from "react";
import { IconButton, Box, Typography, useTheme } from "@mui/material";
import { areDayMealsModifiable } from "../utils/permissions";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useBranding } from "../../Shared/components/BrandingProvider/BrandingProvider";
import "../utils/myMealsCSS.css";

/**
 * MealTabEdit -
 * Displays how many meals are selected out of the available and a button to open the EditMealDialog.
 * @param {*} props
 * @returns
 */
const MealTabEdit = (props) => {
  const {
    branding: {
      PrimarySiteColor
    }
  } = useBranding();
  const theme = useTheme();
  return (
    <Box display="flex" alignItems="center" sx={{ height: "4rem" }} id="mealTabEdit">
        {props.filled && <CheckCircleIcon sx={{ color: theme.palette.success.main, marginRight: theme.spacing(1) }} />}
        <Typography sx={{ color: props.filled && theme.palette.success.main }}>
          {props.selectedRecipes} / {props.currentMealTab.Quantity} selected
        </Typography>
      {areDayMealsModifiable(props.day.Config) &&
        !props.RestrictMealQuantitySelection &&
        !props.RestrictAddRemoveDays &&
        props.currentMealTab && (
          <IconButton
            size="small"
            style={{
              marginLeft: theme.spacing(2),
              border: `2px solid ${PrimarySiteColor.Color}`,
              padding: theme.spacing(.5),
            }}
            variant="text"
            onClick={props.onClick(props.currentMealTab)}
          >
            <EditIcon fontSize="inherit" className="meal-type-edit-meal" />
          </IconButton>
        )}
    </Box>
  );
};

export default MealTabEdit;
